import React from 'react';
import ReactDOM from 'react-dom';
import ReactCrop from 'react-image-crop';
import Modal from 'react-modal';
import HelpOutline from '@material-ui/icons/HelpOutline';
import ImgIconComp from './imgcomp';
import PopUpApp from './PopUpApp';
import { replaceS3Key, replaceSpecicalCharacter } from '../utils/services';
import { validateImageFileExtension } from '../utils/common';
import { imgUrl } from '../utils/url';
import { withTranslation } from 'react-i18next';
import { hot } from 'react-hot-loader/root';

import TimezoneInput, { DEFAULT_TIMEZONE } from './timezone-input';
import { updateMemberProfileAndCover } from '../services/fileupload.service';
import { v4 as uuidv4 } from 'uuid';

import {
  LanguageLocales,
  DEFAULT_LOCALE_CODE_PREFERENCE,
  LocaleToLanguageMapper,
} from '../../../../translations/language_locales';
import { IconButton, Dropdown } from '@workboard/wobo-ui';
import styled from 'styled-components';
const StyledIconButton = styled(IconButton)`
  &.MuiButtonBase-root {
    width: 14px;
    height: 14px;
  }
  svg {
    width: 14px;
    height: 14px;
  }
`;
const StyledDropdown = styled(Dropdown)`
  min-width: 113px !important;
  max-width: fit-content;
  height: 39px !important;
  > svg {
    margin-right: 10px !important;
  }
  .MuiSelect-root {
    height: 38px;
  }
`;

const ErrorMessage = styled.div`
  &.errorMessage {
    margin-top: 12px;
  }
`;

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    maxHeight: '75%',
  },
};

class ProfileApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: this.props.profileData.model.firstname,
      lastname: this.props.profileData.model.lastname,
      email: this.props.profileData.model.email,
      showPassword: this.props.profileData.showPassword,
      newEmail: '',
      verifyEmail: '',
      oldPassword: '',
      password: '',
      verifyPassword: '',
      title: this.props.profileData.profiles.title,
      company: this.props.profileData.profiles.company,
      selected_company: this.props.profileData.profiles.selected_company,
      cell_num: this.props.profileData.model.cell_num,
      timeZoneVal: this.props.profileData.model.timeZoneVal,
      timezone: this.props.profileData.model.timezone,
      coAuthorLanguage: this.props.profileData.model.co_author_language ?? 'English',
      titleError: '',
      cellError: '',
      companyList: [],
      companyListShow: false,
      company_ccid: this.props.profileData.profiles.ccid,
      successMsg: '',
      showPopupVal: false,
      errorFirstName: '',
      errorLastName: '',
      language: this.props.profileData.model.language,
      languageApplyToAllPlatformLabels: this.props.profileData.preference?.languageApplyToAllPlatformLabels || false,
      localizationStatus: this.props.profileData.localizationStatus,
      showCoAuthorLanguageSelection: this.props.profileData.showCoAuthorLanguageSelection,
      enablePlatformLang: this.props.profileData.enablePlatformLang,
    };
    const { t } = this.props;
    this.handleChange = this.handleChange.bind(this);
    this.handleErrorChange = this.handleErrorChange.bind(this);
    this.validateBasicInputFiled = this.validateBasicInputFiled.bind(this);
    this.CollectInputValue = this.CollectInputValue.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleProfileChange = this.handleProfileChange.bind(this);
    this.handleMobilChange = this.handleMobilChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.selectCompany = this.selectCompany.bind(this);
    this.resetMultiSelect = this.resetMultiSelect.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.adjustTimezone = this.adjustTimezone.bind(this);
    this.adjustCoAuthorLanguage = this.adjustCoAuthorLanguage.bind(this);
    this.initPendoVisitorReport = this.initPendoVisitorReport.bind(this);

    // Load co-author language options from translations config
    this.coAuthorLanguageOptions = this.getCoAuthorLanguageOptions();
    this.updateAgentSettingsTimezone = this.updateAgentSettingsTimezone.bind(this);
  }

  getCoAuthorLanguageOptions() {
    // Use the language locales config that's passed in from the server
    const languageConfig = this.props.profileData.languageConfig || window.wbConfig?.languageConfig;

    if (languageConfig && languageConfig.supported_languages) {
      // Always show all languages for co-author selection, regardless of localization settings
      return languageConfig.supported_languages
        .filter((lang) => lang.enabled)
        .map((lang) => ({
          name: lang.value,
          value: lang.value,
        }));
    }

    // Fallback to hardcoded options if config is not available
    return [
      { name: 'Czech', value: 'Czech' },
      { name: 'Dutch', value: 'Dutch' },
      { name: 'English', value: 'English' },
      { name: 'French', value: 'French' },
      { name: 'German', value: 'German' },
      { name: 'Italian', value: 'Italian' },
      { name: 'Japanese', value: 'Japanese' },
      { name: 'Mandarin', value: 'Mandarin' },
      { name: 'Polish', value: 'Polish' },
      { name: 'Portuguese', value: 'Portuguese' },
      { name: 'Russian', value: 'Russian' },
      { name: 'Slovak', value: 'Slovak' },
      { name: 'Spanish', value: 'Spanish' },
      { name: 'Korean', value: 'Korean' },
      { name: 'Finnish', value: 'Finnish' },
    ];
  }

  getUserLanguageOptions() {
    // For user language preference, filter based on localization settings
    const languageConfig = this.props.profileData.languageConfig || window.wbConfig?.languageConfig;
    const isLocalizationEnabled = this.props.profileData.isLocalizationEnabled;

    if (languageConfig && languageConfig.supported_languages) {
      let languages = languageConfig.supported_languages.filter((lang) => lang.enabled);

      // If localization is disabled, only show English for UI language selection
      if (!isLocalizationEnabled) {
        languages = languages.filter((lang) => lang.locale === 'en');
      }

      return languages.map((lang) => ({
        name: lang.value,
        value: lang.locale,
      }));
    }

    // Fallback - if localization disabled, only English
    if (!isLocalizationEnabled) {
      return [{ name: 'English', value: 'en' }];
    }

    // Full fallback list
    return [
      { name: 'English', value: 'en' },
      { name: 'French', value: 'fr' },
      { name: 'German', value: 'de' },
      { name: 'Spanish', value: 'es' },
      { name: 'Mandarin', value: 'zh-cn' },
      { name: 'Japanese', value: 'ja' },
      { name: 'Italian', value: 'it' },
      { name: 'Dutch', value: 'nl' },
      { name: 'Portuguese', value: 'pt' },
      { name: 'Russian', value: 'ru' },
      { name: 'Korean', value: 'ko' },
      { name: 'Finnish', value: 'fi' },
    ];
  }

  componentDidMount() {
    this.initPendoVisitorReport();
    const telInput = $('#cell_number');
    // initialise plugin
    telInput.intlTelInput({
      nationalMode: true,
      autoHideDialCode: true,
      customPlaceholder(selectedCountryPlaceholder, selectedCountryData) {
        $('#cell_number').attr('data-ptext', selectedCountryPlaceholder);
        return '';
      },
    });
    // listen to the telephone input for changes
    telInput.on('countrychange', (e, countryData) => {
      $('.pfSettingsMainDiv .profilePageInput').trigger('blur');
    });
    window.wbConfig.user_locale = this.props.profileData.model.language || DEFAULT_LOCALE_CODE_PREFERENCE;
    window.addEventListener('click', this.handleClick, true);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.profileData.model.timezone !== this.props.profileData.model.timezone) {
      this.setState({
        timezone: this.props.profileData.model.timezone,
      });
    }
  }

  initPendoVisitorReport() {
    if (this.props.profileData?.isPendoEnabled) {
      window.trackPendoVisitorReport?.();
    }
  }

  handleChange(e) {
    const { name } = e.target;
    const { value } = e.target;
    const { state } = this;
    state[name] = value;
    this.setState(state);
  }

  handleErrorChange(name, value) {
    const { state } = this;
    state[name] = value;
    this.setState(state);
  }

  adjustCoAuthorLanguage(coAuthorLanguage) {
    this.setState(
      {
        coAuthorLanguage: coAuthorLanguage.target.value,
      },
      () => {
        this.CollectInputValue();
      },
    );
  }

  validateBasicInputFiled() {
    const _this = this;
    const { t } = this.props;
    if (_this.state.firstname.length < 2) {
      _this.setState({
        errorFirstName: t('First name is too short (minimum is 2 characters).'),
        errorLastName: '',
      });
      return false;
    }
    if (_this.state.lastname.length < 2) {
      _this.setState({
        errorLastName: t('last name is too short (minimum is 2 characters).'),
        errorFirstName: '',
      });
      return false;
    }
    if (_this.state.title != null && _this.state.title.length < 3 && _this.state.title.length > 0) {
      _this.setState({
        titleError: t('Title is too short (minimum is 3 characters).'),
      });
      return false;
    }
    return true;
  }

  CollectInputValue(e) {
    const { t } = this.props;
    const profileData = this.props.profileData.profiles;
    let FormData = {};
    const Profile = {};
    const User = {};
    const UpdateProfile = {};
    const UserChangePassword = {};
    Profile.first_name = this.state.firstname;
    Profile.last_name = this.state.lastname;
    /* if(this.state.title !== null && this.state.title.length < 3 &&  this.state.title.length > 0){
            return false;
        } */
    Profile.title = this.state.title;
    Profile.company = this.state.company;
    Profile.company_ccid = this.state.company_ccid;
    Profile.selected_company = this.state.selected_company;
    Profile.co_author_language = this.state.coAuthorLanguage;
    User.email = this.state.email;
    User.cell_num = this.state.cell_num;
    User.timezone = this.state.timezone;
    UpdateProfile.newEmail = this.state.newEmail;
    UpdateProfile.verifyEmail = this.state.verifyEmail;
    UserChangePassword.oldPassword = this.state.oldPassword;
    UserChangePassword.password = this.state.password;
    UserChangePassword.verifyPassword = this.state.verifyPassword;
    FormData.file = '';
    FormData.mailchanged = '';
    FormData.loopedAIEmail = '';
    FormData.enableRBR = '';
    FormData.tooltip = '';
    FormData.workViewPagePref = '';
    FormData.startPagePref = '';
    FormData.referrer_page_settings = '';
    FormData.imgUpdated = '';
    if (this.validateBasicInputFiled()) {
      FormData = {
        Profile,
        User,
        UpdateProfile,
        UserChangePassword,
        languageApplyToAllPlatformLabels: this.state.languageApplyToAllPlatformLabels,
      };
      setTimeout(() => this.setState({ successMsg: t('Profile Updated') }), 1);
      $.ajax({
        url: `${wbConfig.baseUrl}/user/profile/myPreferences`,
        type: 'POST',
        data: FormData,
      }).done((resp) => {
        if (
          User.email != UpdateProfile.newEmail &&
          UpdateProfile.newEmail == UpdateProfile.verifyEmail &&
          UpdateProfile.newEmail != ''
        ) {
          window.location.href = `${wbConfig.baseUrl}/user/profile/edit`;
        } else if (Profile.first_name != profileData.first_name) {
          $('.loggedUserClass').find('.userName').html(`Hi, ${Profile.first_name}`);
        }
        if (Profile.first_name != profileData.first_name || Profile.last_name != profileData.last_name) {
          const userInfoChannel = new BroadcastChannel('classic: userInfo');
          let username = new Object();
          username.first_name = Profile.first_name;
          username.last_name = Profile.last_name;
          userInfoChannel.postMessage(JSON.stringify(username));
        }
      });
      setTimeout(() => this.setState({ successMsg: '' }), 2000);
    }
  }

  handleSubmit() {
    if (
      !$('.profilePageInput').is(e.target) && // if the target of the click isn't the container...
      $('.profilePageInput').has(e.target).length != 0
    ) {
      console.log($('.profilePageInput').is(e.target));
    }
    return false;
    $.ajax({
      url: `${wbConfig.baseUrl}/Profile/myPreferences`,
      type: 'POST',
      dataType: 'json',
      data: params,
    });
  }

  handleProfileChange(e) {
    const { t } = this.props;
    const strValue = e.target.value;
    const _this = this;

    if (e.target.name == 'title') {
      if (strValue.length < 3 && strValue.length > 0) {
        this.handleErrorChange('titleError', t('Title is too short (minimum is 3 characters).'));
        // setTimeout(() => _this.setState({ titleError: 'Title is too short (minimum is 3 characters).' }), 1);
      } else if (strValue.length < 0) {
        this.handleErrorChange('titleError', '');
        // setTimeout(() => _this.setState({ titleError: '' }), 1);
      } else {
        this.handleErrorChange('titleError', '');
        // setTimeout(() => _this.setState({ titleError: '' }), 1);
      }
      _this.handleChange(e);
    }
  }

  handleMobilChange(e) {
    const { t } = this.props;
    const _this = this;
    const cellNum = $('#cell_number');
    let selectedCountry;
    _this.handleChange(e);
    if (e.target.value) {
      selectedCountry = cellNum.intlTelInput('getSelectedCountryData');
      if (jQuery.isEmptyObject(selectedCountry)) {
        setTimeout(() => _this.setState({ cellError: t('Please enter valid mobile number.') }), 10);
        return false;
      }
      if (!cellNum.intlTelInput('isValidNumber')) {
        $('#UpdateProfile_cell_num_em').html(
          `<div>` +
            t('Please enter valid mobile number') +
            `</div><div style="margin-top: 0px;text-align: left;padding-left: 0px;">` +
            t('For ex') +
            `: ${cellNum.attr('data-ptext')}</div>`,
        );
        return false;
      }
      const telNum = cellNum.intlTelInput('getNumber');
      $('#UpdateProfile_cell_num_em').html('');
      setTimeout(
        () =>
          _this.setState({
            cellError: '',
            cell_num: telNum,
          }),
        10,
      );
    } else {
      $('#UpdateProfile_cell_num_em').html('');
      setTimeout(() => _this.setState({ cellError: '' }), 10);
    }
    _this.CollectInputValue(e);
  }

  handleInputChange(e) {
    const _this = this;
    const serachText = e.target.value;
    setTimeout(() => _this.setState({ company: serachText }), 0);

    $.ajax({
      url: `${wbConfig.baseUrl}/user/Registration/FindCompany`,
      type: 'get',
      data: {
        term: e.target.value,
      },
      dataType: 'json',
    }).done((response) => {
      setTimeout(() => _this.setState({ companyList: response, companyListShow: false }), 0);
    });
  }

  selectCompany(id, name) {
    const _this = this;
    setTimeout(
      () =>
        _this.setState({
          company: name,
          company_ccid: id,
          selected_company: name,
          companyListShow: false,
        }),
      10,
    );

    setTimeout(() => {
      _this.CollectInputValue();
    }, 30);
  }

  resetMultiSelect(id) {
    // let _this = this;
    this.setState({
      showPopupVal: id,
    });
    this.state.showPopupVal = id;
  }

  handleClick(e) {
    if (
      !$('.multiSelectClick').is(e.target) && // if the target of the click isn't the container...
      $('.multiSelectClick').has(e.target).length === 0
    ) {
      const _this = this;
      _this.setState({
        showPopupVal: false,
      });
    }
  }

  async updateAgentSettingsTimezone(timezone) {
    if (!timezone) return;

    const agents = ['chief_of_staff.persona.luisa', 'leadership_coach.persona.sofia'];

    const requests = agents.map((personaId) => {
      const url = `${window.origin}/wb/vnext/agent-bff-api/agent-setting/${personaId}/timezone`;

      return fetch(url, {
        method: 'PATCH',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ timezone }),
      }).then(async (res) => {
        if (!res.ok) {
          throw new Error(`Request failed for ${personaId}`);
        }
        return res.json();
      });
    });

    const results = await Promise.allSettled(requests);

    const successes = [];
    const failures = [];

    results.forEach((result, index) => {
      const agent = agents[index];

      if (result.status === 'fulfilled') {
        successes.push(agent);
      } else {
        failures.push({ agent, error: result.reason });
      }
    });

    if (failures.length) {
      console.error('Failed updates:', failures);
    }

    return { successes, failures };
  }

  adjustTimezone(timezone) {
    this.setState(
      {
        timezone,
      },
      async () => {
        this.CollectInputValue();
        // update agent-settings timezone also
        await this.updateAgentSettingsTimezone(timezone);
      },
    );
  }

  render() {
    const timeZoneList = this.props.profileData.timeZone;
    const { model } = this.props.profileData;
    const { orgName, orgDomain } = this.props.profileData;
    const executeModule = this.props.profileData.executeModule || false;
    const profile = this.props.profileData.profiles;
    // let userAttributes = this.props.profileData.userAttributes;
    const leftPadding = '';
    const rightPadding = '25px 0 10px 0px';
    const { errorSummary } = this.props.profileData;
    const { companyList } = this.state;
    const { actions } = this.state;
    let { userAttributes } = this.props.profileData;
    const { isEntCust } = this.props.profileData;
    const { orgRootVal } = this.props.profileData;
    userAttributes = userAttributes.sort((a, b) => parseInt(b.id) - parseInt(a.id));
    // console.log(this.state.errorFirstName);
    const { t } = this.props;
    return (
      <div id="tm_" className="tmMr tmBodyText" style={{ backgroundColor: '#ffffff', marginTop: '3px' }}>
        {errorSummary.length != '' && (
          <div className="errorSummary" style={{ textAlign: 'center', padding: '10px' }}>
            <p>{t('Please fix the following input errors')}:</p>
            <ul>
              <li>{errorSummary}</li>
            </ul>
          </div>
        )}
        {this.state.successMsg && (
          <div style={{ height: '30px' }}>
            <div
              className="success"
              style={{
                padding: '0px 10px 10px 10px',
                color: '#78C047',
                fontWeight: 'bold',
                textAlign: 'center',
              }}
            >
              {this.state.successMsg}
            </div>
          </div>
        )}
        <h1 className="settingHeader">{t('Profile Settings')}</h1>
        <div className="profileComp">
          <div className="profileContent">
            <div className="pfSettingsMainDiv">
              <div className="profileSubHeader">{t('Account Info')}</div>
              <MyProfile
                userInfo={model}
                CollectInputValue={this.CollectInputValue}
                state={this.state}
                handleChange={this.handleChange}
                isEntCust={isEntCust}
                orgRoot={orgRootVal}
                handleErrorChange={this.handleErrorChange}
                t={t}
              />
              <div id="profileUserDetailSpacerRow" />

              {executeModule ? <EmailAddress userInfo={model} orgName={orgName} orgDomain={orgDomain} t={t} /> : ''}
              <div id="profileUserDetailSpacerRow" />
            </div>

            <div className="profilePic">
              <div className="picHeader" style={{ display: 'inline-block' }}>
                {t('Photo')}
              </div>
              <PhotoComp
                userInfo={model}
                state={this.state}
                isFUSEnabled={this.props.profileData.isFUSEnabled}
                appinID={this.props.profileData.appinID}
                accessToken={this.props.profileData.accessToken}
                t={t}
              />
              <div id="profileUserDetailSpacerRow" />

              <div className="profileTitle">
                <span className="profileSettingLabel">
                  <label htmlFor="Profile_title">{t('Title')}</label>
                </span>
                <span className="profileSettingTextbox input">
                  <input
                    size="60"
                    maxLength="128"
                    className="gbl-text-entry profilePageInput"
                    name="title"
                    id="Profile_title"
                    type="text"
                    value={this.state.title}
                    onChange={(e) => this.handleProfileChange(e)}
                    onBlur={(e) => this.CollectInputValue(e)}
                  />
                </span>
                <ErrorMessage className="errorMessage" id="UpdateProfile_title_em">
                  {this.state.titleError}
                </ErrorMessage>
              </div>
              <div className="profileCompany">
                <span className="profileSettingLabel">
                  <label htmlFor="Profile_company_">{t('Company')}</label>
                </span>
                <span className="profileSettingTextbox input">
                  <input
                    size="60"
                    maxLength="128"
                    className="gbl-text-entry profilePageInput ui-autocomplete-input"
                    name="company"
                    id="Profile_company"
                    type="text"
                    value={this.state.company}
                    autoComplete="off"
                    onChange={(e) => this.handleInputChange(e)}
                    onBlur={(e) => this.CollectInputValue(e)}
                  />
                  {this.state.companyListShow && companyList != null && companyList != '' && (
                    <div className="companyArra">
                      {Object.keys(this.state.companyList).map((items, i) => (
                        <div
                          className="hoverCompany"
                          data-id={items}
                          onClick={(e) => this.selectCompany(items, this.state.companyList[items].name)}
                        >
                          {this.state.companyList[items].name}
                        </div>
                      ))}
                    </div>
                  )}
                  <span role="status" aria-live="polite" className="ui-helper-hidden-accessible" />
                  <input
                    size="60"
                    maxLength="128"
                    style={{ display: 'none' }}
                    name="company_ccid"
                    id="Profile_company_ccid"
                    type="hidden"
                    value={this.state.company_ccid}
                  />
                  <input
                    size="60"
                    id="selected_company"
                    maxLength="128"
                    style={{ display: 'none' }}
                    name="selected_company"
                    type="hidden"
                    value={this.state.company}
                  />
                </span>
              </div>
              <div id="profileUserDetailSpacerRow" />

              <div className="">
                <span className="profileSettingLabel">
                  <label htmlFor="User_Mobile_#">{t('Mobile')} #</label>
                </span>
                <span className="profileSettingTextbox input">
                  <input
                    size="60"
                    maxLength="128"
                    id="cell_number"
                    className="gbl-text-entry profilePageInput"
                    name="cell_num"
                    type="text"
                    value={this.state.cell_num}
                    autoComplete="off"
                    data-ptext=""
                    onChange={(e) => this.handleMobilChange(e)}
                  />
                </span>
                <ErrorMessage className="errorMessage" id="UpdateProfile_cell_num_em">
                  {this.state.cellError}
                </ErrorMessage>
                {executeModule && (
                  <p className="helpText" style={{ float: 'left', paddingLeft: '90px', paddingTop: '3px' }}>
                    {t('Elite subscribers can text themselves issues to 650-204-8988.')}
                  </p>
                )}
              </div>
              <div id="profileUserDetailSpacerRow" />

              <div
                style={{
                  padding: '10px 0 5px 00px',
                  fontWeight: 'bold',
                  fontSize: '16px',
                  color: '#333943',
                }}
              >
                {t('Time Zone')}
              </div>
              <TimezoneInput
                placeholder="Timezone"
                className="profile-timezone"
                timezoneValue={this.state.timezone || DEFAULT_TIMEZONE}
                onSelect={this.adjustTimezone}
              />
              {this.state.showCoAuthorLanguageSelection ? (
                <>
                  <div
                    style={{
                      padding: '10px 0 5px 00px',
                      fontWeight: 'bold',
                      fontSize: '16px',
                      color: '#333943',
                    }}
                  >
                    {t('Select Co-Author Language')}
                  </div>

                  {/* Container for dropdown and checkbox side by side */}
                  <div style={{ display: 'flex', alignItems: 'flex-start', gap: '20px' }}>
                    {/* Language dropdown - restored to original implementation */}
                    <div style={{ flex: '0 0 auto' }}>
                      <StyledDropdown
                        options={this.coAuthorLanguageOptions}
                        defaultValue="English"
                        onChange={this.adjustCoAuthorLanguage}
                        optionTitleProp="name"
                        optionValueProp="value"
                        value={this.state.coAuthorLanguage}
                      />
                    </div>

                    {/* Apply to all platform labels checkbox */}
                    {this.state.localizationStatus && this.state.enablePlatformLang && (
                      <div style={{ flex: '0 0 auto', paddingTop: '8px' }}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            padding: '5px',
                            userSelect: 'none',
                          }}
                          onClick={(e) => {
                            const newValue = !this.state.languageApplyToAllPlatformLabels;
                            this.setState({ languageApplyToAllPlatformLabels: newValue }, () => {
                              // Auto-save the preference with the main form
                              this.CollectInputValue();
                            });
                          }}
                        >
                          <div
                            style={{
                              width: '16px',
                              height: '16px',
                              border: '2px solid #ccc',
                              borderRadius: '3px',
                              marginRight: '8px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backgroundColor: this.state.languageApplyToAllPlatformLabels ? '#007cba' : 'white',
                              borderColor: this.state.languageApplyToAllPlatformLabels ? '#007cba' : '#ccc',
                            }}
                          >
                            {this.state.languageApplyToAllPlatformLabels && (
                              <span style={{ color: 'white', fontSize: '12px', fontWeight: 'bold' }}>✓</span>
                            )}
                          </div>
                          <span style={{ fontSize: '14px', color: '#333943' }}>
                            {t('Apply to all platform labels')}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                ''
              )}
              <div id="profileUserDetailSpacerRow" style={{ paddingTop: '32px' }} />
            </div>
          </div>
        </div>
        {userAttributes.length ? (
          <div className="profileCustomAttrComp">
            {Object.keys(userAttributes).map((items, i) =>
              i % 2 === 0 ? (
                <div
                  className="pfSettingsMainDiv"
                  style={{
                    marginRight: '2%' /* Work around the !important 48% width*/,
                    marginLeft: '0',
                  }}
                >
                  <div className="profileSubHeader">{userAttributes[items].name}</div>
                  {Object.keys(userAttributes[items].attributes).map((row, it) => (
                    <CustomFieldType
                      cusAttributes={userAttributes[items].attributes[row]}
                      ccid={userAttributes[items].id}
                      actions={this.props.actions}
                      showPopupVal={this.state.showPopupVal}
                      resetMultiSelect={this.resetMultiSelect}
                      t={t}
                    />
                  ))}
                </div>
              ) : (
                <div className="profilePic">
                  <div
                    style={{
                      padding: '6px 0px 10px 0px',
                      fontWeight: 'bold',
                      fontSize: '16px',
                      color: '#333943',
                    }}
                  >
                    {userAttributes[items].name}
                  </div>
                  {Object.keys(userAttributes[items].attributes).map((row, it) => (
                    <CustomFieldType
                      cusAttributes={userAttributes[items].attributes[row]}
                      ccid={userAttributes[items].id}
                      actions={this.props.actions}
                      showPopupVal={this.state.showPopupVal}
                      resetMultiSelect={this.resetMultiSelect}
                      t={t}
                    />
                  ))}
                </div>
              ),
            )}
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

class CustomFieldType extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const cusattributes = this.props.cusAttributes;
    const { ccid } = this.props;
    let textField = false;
    let textArea = false;
    let dropDown = false;
    let multiSelect = false;
    const { actions } = this.props;
    const { t } = this.props;
    if (cusattributes.field_type_id == 1) {
      textField = true;
    } else if (cusattributes.field_type_id == 2) {
      textArea = true;
    } else if (cusattributes.field_type_id == 3) {
      dropDown = true;
    } else if (cusattributes.field_type_id == 4) {
      multiSelect = true;
    }
    const fieldValue = {};
    return (
      <div style={{ padding: '10px 0px' }}>
        {textField && (
          <TextField customattributes={cusattributes} ccid={this.props.ccid} actions={this.props.actions} />
        )}
        {textArea && (
          <TextArea customattributes={cusattributes} ccid={this.props.ccid} actions={this.props.actions} t={t} />
        )}

        {dropDown && <DropDown customattributes={cusattributes} ccid={this.props.ccid} actions={this.props.actions} />}
        {multiSelect && (
          <MultiSelect
            customattributes={cusattributes}
            ccid={this.props.ccid}
            actions={this.props.actions}
            showPopupVal={this.props.showPopupVal}
            resetMultiSelect={this.props.resetMultiSelect}
          />
        )}
        <div id="profileUserDetailSpacerRow" />
      </div>
    );
  }
}

/*
 * My Profile Comp
 */
class MyProfile extends React.Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    this.state = {
      showEditEmail: false,
      showEditPassword: false,
      verifyEmailErrors: '',
      emailFormatError: t('Please provide Email Id in correct format.'),
      emailBusinesError: t('User must be from your corporate email domain.'),
      newEmailErrors: '',
      passWordError: '',
      UserChangePassword_oldPassword: '',
      UserChangePassword_password: '',
      UserChangePassword_verifyPassword: '',
      errorFirstName: this.props.errorFirstName,
      errorLastName: this.props.errorLastName,
      newPasswrd: '',
      repPasswrd: '',
    };
    this.onShowEditEmail = this.onShowEditEmail.bind(this);
    this.onShowEditPassword = this.onShowEditPassword.bind(this);
    this.handleProfileChange = this.handleProfileChange.bind(this);
    this.ValidateEmail = this.ValidateEmail.bind(this);
    this.emailConfirm = this.emailConfirm.bind(this);
    this.validateOldPassword = this.validateOldPassword.bind(this);
    this.saveDeactiveAccount = this.saveDeactiveAccount.bind(this);
    this.userFirstLastNameValidation = this.userFirstLastNameValidation.bind(this);
    this.onShowMfaPopup = this.onShowMfaPopup.bind(this);
  }

  onShowEditEmail() {
    const _this = this;
    setTimeout(
      () =>
        _this.setState({
          showEditEmail: !_this.state.showEditEmail,
          verifyEmailErrors: '',
          newEmailErrors: '',
          passWordError: '',
        }),
      10,
    );
  }

  onShowEditPassword() {
    const _this = this;
    setTimeout(
      () =>
        _this.setState({
          showEditPassword: !_this.state.showEditPassword,
          UserChangePassword_oldPassword: '',
          UserChangePassword_password: '',
          UserChangePassword_verifyPassword: '',
        }),
      10,
    );
  }

  onShowMfaPopup() {
    fetch(`${wbConfig.baseUrl}/user/login/mfaPopup`, {
      method: 'POST',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('error: ' + response.statusText);
        }
        return response.text();
      })
      .then((data) => {
        document.getElementById('mfaModalContainer').innerHTML = data;
        const container = document.getElementById('mfaModalContainer');
        const scripts = container.getElementsByTagName('script');
        for (let i = 0; i < scripts.length; i++) {
          const script = document.createElement('script');
          script.text = scripts[i].text;
          document.head.appendChild(script).parentNode.removeChild(script);
        }
        // Assuming we have a modal element with id 'mfaModal'
        const modal = document.getElementById('mfaModal');
        if (modal) {
          modal.style.display = 'block';
        }
      })
      .catch((error) => {
        console.error('Fetch Error:', error);
      });
  }

  handleProfileChange(e) {
    this.props.handleChange(e);
  }

  ValidateEmail(e) {
    const { t } = this.props;
    const { state } = this.props;
    const { name } = e.target;
    const _this = this;
    e.preventDefault();
    const params = {};
    if (e.target.name == 'newEmail') {
      $('#UpdateProfile_verifyEmail').attr('disabled', 'disabled');
      if (e.target.value != '' && state.email == e.target.value) {
        setTimeout(() => _this.setState({ newEmailErrors: t('Email already exists, please enter another email.') }), 0);
        return false;
      }
      if (e.target.value != '' && state.email != e.target.value) {
        $.ajax({
          url: `${wbConfig.baseUrl}/user/profile/verifyEMailExists`,
          type: 'POST',
          dataType: 'json',
          data: { emailId: e.target.value },
        }).done((resp) => {
          if (resp.status == 'error') {
            setTimeout(() => _this.setState({ newEmailErrors: resp.msg }), 0);
            $('#UpdateProfile_verifyEmail').attr('disabled', 'disabled');
            return false;
          } else {
            $('#UpdateProfile_verifyEmail').removeAttr('disabled');
          }
        });
      }
      if (
        /^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-+]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,20})$/.test(
          e.target.value,
        ) &&
        validateDisallowReg(e.target.value)
      ) {
        _this.setState({
          newEmailErrors: '',
          verifyEmailErrors: '',
        });
        _this.props.handleChange(e);
      } else {
        if (!validateDisallowReg(e.target.value)) {
          _this.setState({ newEmailErrors: this.state.emailBusinesError });
        } else {
          _this.setState({ newEmailErrors: this.state.emailFormatError });
        }
        // e.target.focus();
      }
    } else if (e.target.name == 'verifyEmail') {
      if (e.target.value == '') {
        _this.setState({
          verifyEmailErrors: t('Verify Email is incorrect'),
        });
      }
      if (e.target.value != state.newEmail) {
        _this.setState({
          verifyEmailErrors: t('Verify Email is incorrect'),
        });
      } else {
        _this.setState({
          verifyEmailErrors: '',
          newEmailErrors: '',
          passWordError: '',
          showEditEmail: !_this.state.showEditEmail,
        });
        _this.props.handleChange(e);
        if (e.target.value != '' && state.newEmail != '') {
          const oldEmail = state.email;
          const newEmail = e.target.value;
          _this.emailConfirm(oldEmail, newEmail);
        }
      }
    }
  }

  emailConfirm(oldEmail, newEmail) {
    $(emailPopConfirmation).dialog('open').html('');
    ReactDOM.render(
      <ViewEmailPopup
        CollectInputValue={this.props.CollectInputValue}
        OldEmail={oldEmail}
        NewEmail={newEmail}
        t={this.props.t}
      />,
      document.getElementById('emailPopConfirmation'),
    );
  }

  validateOldPassword(e) {
    const { t } = this.props;
    const { state } = this.props;
    const params = {};
    const _this = this;
    const str1 = state.firstname;
    // var str2 = str1.toLowerCase();
    const str3 = state.lastname;
    // var str4 = str3.toLowerCase();
    const firstLastName = str1.toLowerCase() + str3.toLowerCase();
    if (e.target.name == 'oldPassword') {
      if (e.target.value == '') {
        setTimeout(
          () =>
            _this.setState({
              UserChangePassword_oldPassword: t('Old Password field can`t be empty.'),
            }),
          10,
        );
      } else if (e.target.name == 'oldPassword') {
        if (e.target.value != '') {
          params.oldPassword = e.target.value;
          $.ajax({
            url: `${wbConfig.baseUrl}/user/profile/validatePassWord`,
            type: 'POST',
            dataType: 'json',
            data: params,
          }).done((resp) => {
            if (resp.status == 'error') {
              setTimeout(() => _this.setState({ UserChangePassword_oldPassword: resp.msg }), 10);
            } else {
              setTimeout(() => {
                if (
                  _this.state.newPasswrd != '' &&
                  _this.state.repPasswrd != '' &&
                  _this.state.UserChangePassword_password == '' &&
                  _this.state.UserChangePassword_verifyPassword == '' &&
                  _(this.state.newPasswrd == _this.state.repPasswrd)
                ) {
                  _this.setState({
                    showEditPassword: false,
                    newPasswrd: '',
                    repPasswrd: '',
                  });
                  _this.props.CollectInputValue('password', _this.state.newPasswrd);
                }
                _this.setState({ UserChangePassword_oldPassword: '' });
              }, 10);
              //_this.props.handleChange(e);
            }
          });
        }
        _this.props.handleChange(e);
      } else {
        _this.props.handleChange(e);
        setTimeout(() => _this.setState({ UserChangePassword_oldPassword: '' }), 10);
      }
    } else if (e.target.name == 'password') {
      _this.setState({
        newPasswrd: e.target.value,
      });
      if (e.target.value == state.firstname) {
        _this.setState({
          UserChangePassword_password: t('Your password must not contain your user name.'),
        });

        return false;
      }
      if (e.target.value == state.lastname) {
        _this.setState({
          UserChangePassword_password: t('Your password must not contain your user name.'),
        });

        return false;
      }
      if (e.target.value.length < 12) {
        _this.setState({
          UserChangePassword_password: t(
            'Your password must be at least 12 characters and contain  alphanumeric, special and mixed case.',
          ),
        });

        return false;
      }
      if (state.oldPassword == '') {
        _this.setState({
          UserChangePassword_oldPassword: t('Old Password field can`t be empty.'),
        });

        return false;
      }
      if (state.oldPassword != '') {
        params.oldPassword = state.oldPassword;
        $.ajax({
          url: `${wbConfig.baseUrl}/user/profile/validatePassWord`,
          type: 'POST',
          dataType: 'json',
          data: params,
        }).done((resp) => {
          if (resp.status == 'error') {
            _this.setState({
              UserChangePassword_oldPassword: t('Old Password is incorrect.'),
            });

            return false;
          } else {
            _this.setState({
              UserChangePassword_oldPassword: '',
            });
            return true;
          }
        });
      }
      if (e.target.value != '') {
        if (
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#~`^\(\)_\-\=\+\{\}\[\]:;\"'<>,.\/\\|])[A-Za-z\d@$!%*?&#~`^\(\)_\-\=\+\{\}\[\]:;\"'<>,.\/\\|]{12,}$/.test(
            e.target.value,
          )
        ) {
          _this.setState({
            UserChangePassword_oldPassword: '',
            UserChangePassword_password: '',
          });
          _this.props.handleChange(e);
          return true;
        }
        _this.setState({
          UserChangePassword_password: t('Your password must contain alphanumeric, special, mixed case characters.'),
        });
        // e.target.focus();
        return false;
      }
      const dataVal = {};
      dataVal.password = e.target.value;
      $.ajax({
        url: `${wbConfig.baseUrl}/user/profile/validateNewPassword`,
        type: 'POST',
        dataType: 'json',
        data: dataVal,
      }).done((resp) => {
        if (resp.status == 'error') {
          setTimeout(() => _this.setState({ UserChangePassword_password: resp.msg }), 0);
          return false;
        }
        setTimeout(() => _this.setState({ UserChangePassword_password: '' }), 0);
        _this.props.handleChange(e);
        return true;
      });
    } else if (e.target.name == 'verifyPassword') {
      _this.setState({
        repPasswrd: e.target.value,
      });
      const verifyPass = e.target.value;
      const lowerVerifyPass = verifyPass.toLowerCase();
      console.log('lowerVerifyPass.includes(firstLastName)-----', lowerVerifyPass.includes(firstLastName));
      if (state.oldPassword == '') {
        _this.setState({
          UserChangePassword_oldPassword: t('Old Password field can`t be empty.'),
        });

        return false;
      }
      if (state.password == '') {
        _this.setState({
          UserChangePassword_oldPassword: _this.state.UserChangePassword_oldPassword,
          UserChangePassword_password: _this.state.UserChangePassword_password,
        });

        return false;
      }
      if (e.target.value != state.password) {
        _this.setState({
          UserChangePassword_verifyPassword: t('Verify Password is incorrect '),
        });

        return false;
      }
      if (lowerVerifyPass.includes(firstLastName)) {
        _this.setState({
          UserChangePassword_verifyPassword: t('Password should not contain firstname and lastname '),
        });
        return false;
      }

      if (state.oldPassword != '') {
        params.oldPassword = state.oldPassword;
        $.ajax({
          url: `${wbConfig.baseUrl}/user/profile/validatePassWord`,
          type: 'POST',
          dataType: 'json',
          data: params,
        }).done((resp) => {
          if (resp.status == 'error') {
            _this.setState({
              UserChangePassword_oldPassword: t('Old Password is incorrect.'),
            });
          } else {
            _this.setState({
              UserChangePassword_oldPassword: '',
            });
          }
        });
      }
      if (_this.state.UserChangePassword_oldPassword == '') {
        _this.props.handleChange(e);
        _this.setState({
          UserChangePassword_oldPassword: '',
          UserChangePassword_password: '',
          UserChangePassword_verifyPassword: '',
          showEditPassword: false,
        });
        _this.props.CollectInputValue('password', e.target.value);
      }
    }
  }

  saveDeactiveAccount() {
    $.ajax({
      url: `${wbConfig.baseUrl}/user/profile/deactivateProfile`,
      type: 'POST',
      dataType: 'json',
      data: { status: -1 },
    }).done((resp) => {
      // $('#usr_profile_logout').submit();
      window.location = `${wbConfig.baseUrl}/user/login`;
    });
  }

  userFirstLastNameValidation(e) {
    const { t } = this.props;
    const _this = this;
    const { state } = _this.props;
    e.preventDefault();
    _this.props.handleChange(e);
    if (e.target.name == 'firstname') {
      const lName = state.laststname;
      if (e.target.value == '' || e.target.value.length < 2) {
        this.props.handleErrorChange('errorFirstName', t('First name is too short (minimum is 2 characters).'));
        this.props.handleErrorChange('errorLastName', '');
      } else {
        const lName = state.lastname;
        if (lName.length < 2) {
          this.props.handleErrorChange(
            'errorLastName',
            lName.length < 2 ? t('Last name is too short (minimum is 2 characters).') : '',
          );
          this.props.handleErrorChange(
            'errorFirstName',
            e.target.value.length < 2 ? t('First name is too short (minimum is 2 characters).') : '',
          );
        } else {
          this.props.handleErrorChange('errorFirstName', '');
          this.props.handleErrorChange('errorLastName', '');
          _this.props.CollectInputValue('firstname', e.target.value);
        }
      }
    }
    if (e.target.name == 'lastname') {
      const fName = state.firstname;
      if (e.target.value == '' || e.target.value.length < 2) {
        this.props.handleErrorChange(
          'errorFirstName',
          fName.length < 2 ? t('First name is too short (minimum is 2 characters).') : '',
        );
        this.props.handleErrorChange('errorLastName', t('Last name is too short (minimum is 2 characters).'));
      } else if (fName.length < 2) {
        this.props.handleErrorChange(
          'errorFirstName',
          fName.length < 2 ? t('First name is too short (minimum is 2 characters).') : '',
        );
        this.props.handleErrorChange(
          'errorLastName',
          e.target.value.length < 2 ? t('Last name is too short (minimum is 2 characters).') : '',
        );
      } else {
        this.props.handleErrorChange('errorFirstName', '');
        this.props.handleErrorChange('errorLastName', '');
        _this.props.CollectInputValue('lastname', e.target.value);
      }
    }
  }

  render() {
    const { userInfo } = this.props;
    const { CollectInputValue } = this.props;
    const { state } = this.props;
    const { t } = this.props;
    const property = {
      rootUser: this.props.orgRoot, // user role
      title: t('Account Deactivation'), // title of the popup
      callBack: this.saveDeactiveAccount, // save/callback methord
      param1: t('Are you sure you want to deactivate your Workboard account?'),
      param2: `${t('Once your account is deactivated you won’t be able to login to Workboard or accesss any data.')} ${t('Deactivation is permanent, all data will be lost.')}`,
      param3: t('You are Organization root member.') + ' ' + t('You can`t deactivate your account.'),
    };

    let isMfaRegistered = false;
    let isMfaExempt = false;
    let isSsoExempt = false;
    const isSsoEnabled = !state.showPassword;

    if (window?.wbConfig?.isEnabledMltifactorAuthentication) {
      let userData;
      try {
        userData = JSON.parse(userInfo?.data || '{}');
      } catch (e) {
        userData = {};
      }
      isMfaRegistered =
        userData?.mfa && userData.mfa?.USER_agent_factorSid && userData.mfa.USER_agent_factorSid?.trim() !== '';

      let mfa_exempt_emails = uData?.orgConfig['mfa_login_exception'];
      let mfaEmailList = mfa_exempt_emails ? mfa_exempt_emails.split(',').map((email) => email.trim()) : [];
      if (mfaEmailList.includes(userInfo.email)) {
        isMfaExempt = true;
      } else {
        isMfaExempt = false;
      }

      if (isSsoEnabled) {
        let sso_exempt_emails = uData?.orgConfig['sso_login_exception'];
        let ssoEmailList = sso_exempt_emails ? sso_exempt_emails.split(',').map((email) => email.trim()) : [];
        if (ssoEmailList.includes(userInfo.email)) {
          isSsoExempt = true;
        } else {
          isSsoExempt = false;
        }
      }
    }

    return (
      <div className="changePhoto">
        <div id="profileUserDetailSpacerRow" />
        <div className="profileSettingUserDetails">
          <span className="profileSettingLabel">
            <label htmlFor="Profile_first_name">{t('First Name')}</label>
          </span>
          <span className="profileSettingTextbox input">
            <input
              size="60"
              maxLength="64"
              style={{ fontWeight: 'normal' }}
              className="gbl-text-entry profilePageInput profilePageFirstName"
              name="firstname"
              id="Profile_first_name"
              type="text"
              value={strip_tags(state.firstname)}
              refs="Profile[first_name]"
              onChange={(e) => this.handleProfileChange(e)}
              onBlur={(e) => this.userFirstLastNameValidation(e)}
            />
          </span>
        </div>
        <ErrorMessage className="errorMessage" id="UserChangePassword_verifyPassword_em_">
          {state.errorFirstName}
        </ErrorMessage>
        <div id="profileUserDetailSpacerRow" />
        <div className="profileSettingUserDetails">
          <span className="profileSettingLabel" style={{ lineHeight: '15px' }}>
            <label htmlFor="Profile_last_name">{t('Last Name')}</label>
          </span>
          <span className="profileSettingTextbox input">
            <input
              size="60"
              maxLength="64"
              style={{ fontWeight: 'normal' }}
              className="gbl-text-entry profilePageInput profilePageLastName"
              name="lastname"
              id="Profile_last_name"
              type="text"
              value={strip_tags(state.lastname)}
              onChange={(e) => this.handleProfileChange(e)}
              onBlur={(e) => this.userFirstLastNameValidation(e)}
            />
          </span>
        </div>
        <ErrorMessage className="errorMessage" id="UserChangePassword_verifyPassword_em_">
          {state.errorLastName}
        </ErrorMessage>
        <div id="profileUserDetailSpacerRow" />
        <div className="profileSettingUserDetails">
          <span className="profileSettingLabel">
            <label htmlFor="User_Login_Email">{t('Login Email')}</label>
          </span>
          <span
            className="profileSettingTextbox input"
            style={{ border: 'none' }}
            title={state.email != '' ? state.email : 'email'}
          >
            <input
              size="60"
              maxLength="128"
              readOnly="readonly"
              style={{ border: 'none' }}
              className="profilePageInput"
              name="email"
              id="User_email"
              type="text"
              value={state.email}
            />
          </span>
          <span className="emailedit" onClick={() => this.onShowEditEmail()}>
            {t('Edit')}
          </span>
        </div>
        <div id="profileUserDetailSpacerRow" />
        {this.state.showEditEmail && (
          <div className="emailChange">
            <div className="profileSettingUserDetails">
              <span className="profileSettingLabel" />
              <span className="profileSettingTextbox input">
                <input
                  size="60"
                  maxLength="128"
                  style={{ fontWeight: 'normal' }}
                  placeholder={t('New Email')}
                  className="profilePageInput"
                  name="newEmail"
                  id="UpdateProfile_newEmail"
                  type="text"
                  onBlur={(e) => this.ValidateEmail(e)}
                />
              </span>
            </div>
            <ErrorMessage className="errorMessage" id="UpdateProfile_newEmail_em_">
              {this.state.newEmailErrors}
            </ErrorMessage>

            <div id="profileUserDetailSpacerRow" />
            <div className="profileSettingUserDetails">
              <span className="profileSettingLabel" />
              <span className="profileSettingTextbox input">
                <input
                  size="60"
                  maxLength="128"
                  style={{ fontWeight: 'normal' }}
                  placeholder={t('Verify Email')}
                  className="profilePageInput"
                  name="verifyEmail"
                  id="UpdateProfile_verifyEmail"
                  type="text"
                  onBlur={(e) => this.ValidateEmail(e)}
                />
              </span>
            </div>
            <ErrorMessage className="errorMessage" id="UpdateProfile_verifyEmail_em_">
              {this.state.verifyEmailErrors}
            </ErrorMessage>
            <div id="profileUserDetailSpacerRow" />
          </div>
        )}
        {state.showPassword && (
          <div className="profileSettingUserDetails">
            <span className="profileSettingLabel">
              <label htmlFor="UserChangePassword_Password">{t('Password')}</label>
            </span>
            <span className="profileSettingTextbox input">
              <input
                className="UserChangePassword_oldPassword"
                readOnly="readonly"
                disable="true"
                style={{ border: 'none', marginLeft: '-5px', marginRight: '5px' }}
              />
            </span>
            <span className="pwdedit" onClick={() => this.onShowEditPassword()}>
              {t('Edit')}
            </span>
          </div>
        )}
        <div id="mfaModalContainer"></div>

        <div id="profileUserDetailSpacerRow" />
        {window?.wbConfig?.isEnabledMltifactorAuthentication &&
          !isMfaExempt &&
          (!isSsoEnabled || (isSsoEnabled && isSsoExempt)) && (
            <div className="profileSettingUserDetails">
              <span className="profileSettingLabel" style={{ width: 'auto' }}>
                <label htmlFor="user_mfa">{t('Two-factor authentication')}</label>
              </span>
              <span className="profileSettingTextbox input" style={{ width: '172px', display: 'inline-block' }}></span>
              <span
                className="pwdedit"
                onClick={() => this.onShowMfaPopup()}
                id="editMfa"
                style={{ cursor: 'pointer', color: 'var(--linkTextColor)' }}
              >
                {isMfaRegistered ? t('Edit') : t('Enable')}
              </span>
            </div>
          )}
        {this.state.showEditPassword && (
          <div className="pwdChange">
            <div className="profileSettingUserDetails">
              <span className="profileSettingLabel" />
              <span className="profileSettingTextbox input">
                <input
                  size="60"
                  maxLength="128"
                  initial_value=""
                  style={{ fontWeight: 'normal' }}
                  placeholder={t('Enter current password')}
                  name="oldPassword"
                  id="UserChangePassword_oldPassword"
                  type="password"
                  onBlur={(e) => this.validateOldPassword(e)}
                  refs="oldPassword"
                  autocomplete="new-password"
                />
              </span>
            </div>
            <ErrorMessage className="errorMessage" id="UserChangePassword_oldPassword_em_">
              {this.state.UserChangePassword_oldPassword}
            </ErrorMessage>
            <div id="profileUserDetailSpacerRow" />
            <div className="profileSettingUserDetails">
              <span className="profileSettingLabel" />
              <span className="profileSettingTextbox input">
                <input
                  size="60"
                  maxLength="128"
                  style={{ fontWeight: 'normal' }}
                  placeholder={t('Enter new password')}
                  name="password"
                  id="UserChangePassword_password"
                  type="password"
                  onBlur={(e) => this.validateOldPassword(e)}
                  autocomplete="off"
                />
              </span>
            </div>
            <ErrorMessage className="errorMessage" id="UserChangePassword_password_em_">
              {this.state.UserChangePassword_password}
            </ErrorMessage>
            <div id="profileUserDetailSpacerRow" />
            <div className="profileSettingUserDetails">
              <span className="profileSettingLabel" />
              <span className="profileSettingTextbox input">
                <input
                  size="60"
                  maxLength="128"
                  style={{ fontWeight: 'normal' }}
                  placeholder={t('Enter new password again')}
                  className="profilePageInput"
                  name="verifyPassword"
                  id="UserChangePassword_verifyPassword"
                  type="password"
                  onBlur={(e) => this.validateOldPassword(e)}
                  autocomplete="off"
                />
              </span>
            </div>
            <ErrorMessage className="errorMessage" id="UserChangePassword_verifyPassword_em_">
              {this.state.UserChangePassword_verifyPassword}
            </ErrorMessage>
            <div id="profileUserDetailSpacerRow" />
          </div>
        )}
        {!this.props.isEntCust && (
          <div className="profileSettingUserDetails deactivateAcc">
            <PopUpApp property={property} />
          </div>
        )}
      </div>
    );
  }
}

class ViewEmailPopup extends React.Component {
  constructor(props) {
    super(props);
    this.confirmLogOut = this.confirmLogOut.bind(this);
    this.closeConfirm = this.closeConfirm.bind(this);
  }

  confirmLogOut() {
    this.props.CollectInputValue();
    const params = {};
    setTimeout(() => {
      if ($.ajaxSetup().data.YII_CSRF_TOKEN) {
        params.YII_CSRF_TOKEN = $.ajaxSetup().data.YII_CSRF_TOKEN;
      }
      $(emailPopConfirmation).dialog('close');
      // $( "#logoutSubmitBtn" ).trigger( "click" );
    }, 2000);
  }

  closeConfirm() {
    $(emailPopConfirmation).dialog('close');
  }

  render() {
    const { CollectInputValue, OldEmail, NewEmail } = this.props;
    const { t } = this.props;
    return (
      <div
        data-str="1"
        style={{
          padding: '0px',
          width: 'auto',
          minHeight: '0px',
          height: '190px',
        }}
        className="ui-dialog-content ui-widget-content"
        scrolltop="0"
        scrollleft="0"
      >
        <div
          className="confirmHeading"
          style={{
            marginTop: '10px',
            marginLeft: '20px',
            marginRight: '20px',
            marginBottom: '10px',
          }}
        >
          <div className="smallModalHeadingText" style={{ display: 'inline-block' }}>
            {t('Email Update')}
          </div>
          <div className="confCancel confirmationCancelBtn" style={{ paddingTop: '4px' }} onClick={this.closeConfirm}>
            <img className="closeX" src={imgUrl('/images/ai-v1-assets/x.png')} />
          </div>
        </div>
        <div style={{ height: '1px', borderTop: '1px solid #ccc' }}>&nbsp;</div>
        <div style={{ marginTop: '15px', marginLeft: '20px', marginRight: '20px' }}>
          <div className="confirmText modalMainParaText"> {t('You are changing your login email to')}:</div>
          <div className="modalMainParaText" style={{ marginTop: '10px', marginLeft: '20px' }}>
            {NewEmail}
          </div>
          <div className="modalMainParaText" style={{ marginTop: '10px' }}>
            {t('Do you want to continue')} ?
          </div>
        </div>
        <div className="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
          <div className="ui-dialog-buttonset">
            <button
              type="button"
              className="confirmBtnWrapBtn ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"
              role="button"
              aria-disabled="false"
              onClick={this.confirmLogOut}
            >
              <span className="ui-button-text">{t('Update')}</span>
            </button>
            <button
              type="button"
              className="confirmBtnWrapBtn ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"
              role="button"
              aria-disabled="false"
              onClick={this.closeConfirm}
            >
              <span className="ui-button-text">{t('Cancel')}</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

/*
 * Email Address Comp
 */
const EmailAddress = ({ userInfo, orgName, orgDomain, t }) => {
  // Hide this component completely for EU domain
  if (window.location.origin === 'https://www.myworkboard.eu') {
    return null;
  }

  const isZenry = orgName === 'Zenry';

  const learnHowLink = isZenry
    ? 'https://zenry.zendesk.com/hc/en-us/articles/224330568-Convert-emails-into-action-items'
    : 'https://support.myworkboard.com/en/articles/13516622-add-actions#h_01HPPXQVWJSGQ7H61N7VGXN60R';

  return (
    <div style={{ paddingLeft: '20px', height: '165px' }}>
      <div
        style={{
          fontWeight: 'bold',
          fontSize: '16px',
          color: '#333943',
          padding: '20px 0 15px 0',
        }}
      >
        {t('{{orgName}} Email Address', { orgName })}
      </div>

      <div id="wbEmailId">
        <div style={{ fontSize: '13px' }} id="changePhotoDescription">
          <div>{t('Your {{orgName}} email address is', { orgName })}:</div>
          <div>
            <div>
              <b>{`${userInfo.wb_email}@${orgDomain}`}</b>
            </div>
            <div>{t('Add this email to your contacts to send emails')}</div>
            <div>
              {t('to')} {orgName} {t('as issues')}.{' '}
              <a style={{ color: '#007FAD' }} target="_blank" rel="noreferrer" href={learnHowLink}>
                {t('Learn how')}
              </a>
              .
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/*
 * Profile Image
 */
class PhotoComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageUrl: '',
      crop: {
        aspect: 1,
        width: 30,
        x: 0,
        y: 0,
      },
      imgSrc: '',
      modalIsOpen: false,
      firstUrl: '',
      firstUpload: true,
      isCropped: false,
    };
  }

  onImageLoaded = (image, pixelCrop) => {
    this.imageRef = image;

    // Make the library regenerate aspect crops if loading new images.
    const { crop } = this.state;

    if (crop.aspect && crop.height && crop.width) {
      this.setState({
        crop: { ...crop, height: null },
      });
    } else {
      this.makeClientCrop(crop, pixelCrop);
    }
  };

  onCropComplete = (crop, pixelCrop) => {
    this.makeClientCrop(crop, pixelCrop);
  };

  onCropChange = (crop) => {
    this.setState({ crop });
  };

  async makeClientCrop(crop, pixelCrop) {
    if (this.imageRef && crop.width && crop.height) {
      const [croppedImageUrl, file] = await this.getCroppedImg(this.imageRef, pixelCrop, 'newFile.jpeg');
      this.setState({ croppedImageUrl, file });
      this.setState({ isCropped: true });
    }
  }

  getCroppedImg = (image, pixelCrop, fileName) => {
    const canvas = document.createElement('canvas');
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;
    const ctx = canvas.getContext('2d');

    if (this.state.firstUpload) {
      let img = new Image();
      return new Promise((resolve, reject) => {
        img.onload = function () {
          // draw in image
          ctx.drawImage(
            img,
            pixelCrop.x,
            pixelCrop.y,
            pixelCrop.width,
            pixelCrop.height,
            0,
            0,
            pixelCrop.width,
            pixelCrop.height,
          );
          canvas.toBlob((blob) => {
            blob.name = fileName;
            window.URL.revokeObjectURL(this.fileUrl);
            this.fileUrl = window.URL.createObjectURL(blob);
            let file;
            if (window.navigator.userAgent.indexOf('Edge') > -1 || browserDetection() === 'ie') {
              file = new Blob([blob], { type: 'image/jpeg' });
              file.name = fileName;
            } else {
              file = new File([blob], 'testing');
            }
            resolve([this.fileUrl, file]);
          }, 'image/jpeg');
        };
        img.crossOrigin = 'anonymous'; // if from different origin
        img.src = this.state.firstUrl;
      });
    } else {
      ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        pixelCrop.width,
        pixelCrop.height,
      );
      return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
          blob.name = fileName;
          window.URL.revokeObjectURL(this.fileUrl);
          this.fileUrl = window.URL.createObjectURL(blob);
          let file;
          if (window.navigator.userAgent.indexOf('Edge') > -1 || browserDetection() === 'ie') {
            file = new Blob([blob], { type: 'image/jpeg' });
            file.name = fileName;
          } else {
            file = new File([blob], 'testing');
          }
          resolve([this.fileUrl, file]);
        }, 'image/jpeg');
      });
    }
  };

  openProfileDialog = (imgSrc) => {
    this.setState({
      modalIsOpen: true,
      imgSrc,
      firstUrl: imgSrc,
      cropType: 'profile',
      crop: {
        aspect: 1,
        width: 50,
        x: 0,
        y: 0,
        minWidth: 40,
        minHeight: 40,
      },
    });
  };

  getFile = () => {
    let file = this.refs.file.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = () => {
      this.setState({
        imgSrc: reader.result.toString(),
        modalIsOpen: true,
        crop: {
          aspect: 1,
          width: 30,
          x: 0,
          y: 0,
        },
      });
      return false;
    };
  };

  saveProfileImage = () => {
    const { t } = this.props;
    let { file } = this.state;
    let isFUSEnabled = this.props.isFUSEnabled;
    let saveUrl = `${wbConfig.baseUrl}/user/profile/updateProfilePic`;
    if (isFUSEnabled) {
      let appinID = this.props.appinID;
      let request_id = uuidv4();
      let accessToken = this.props.accessToken;
      let profileUserId = uData.user_id;
      let orgId = uData.org_id;
      updateMemberProfileAndCover(
        file,
        saveUrl,
        { appinID, request_id, accessToken, profileUserId, orgId },
        this.state.isCropped,
        { profileReload: 1, coverReload: 0 },
      );
    } else {
      $.ajax({
        url: `${wbConfig.baseUrl}/workboard/GetS3Data`,
        type: 'POST',
        dataType: 'json',
        data: { authVal: 'public-read' },
      }).done((resp) => {
        let key = replaceS3Key(resp.key, file.name);

        let asc = resp.asc;
        if (resp.encrypt_type !== 'azure:sse') {
          asc = 's3';
          key = resp;
        }
        uploadFileToAzureStorage(asc, key, file, null, 'anonymous')
          .then((result) => {
            let profileParams = { picture: result.filePath };
            $.ajax({
              url: saveUrl,
              type: 'POST',
              data: profileParams,
              dataType: 'json',
              async: true,
              success(res) {
                toastr.success(t('Profile picture updated'));
                // Setting a timeout to handle the window location reload to refresh images across app
                setTimeout(() => {
                  window.location.reload();
                }, 200);
              },
            });
          })
          .catch((e) => {
            toastr.error(`${t('Profile picture could not be updated.')} ${t('Please refresh and try again.')}`);
          });
      });
    }
  };

  deletePhoto = () => {
    let profileUserId = this.props.userInfo.id;
    const { t } = this.props;
    $.post(`${wbConfig.baseUrl}/user/profile/deleteUserProfilePicture`, (response) => {
      let resp = JSON.parse(response);
      if (resp.success) {
        toastr.success(t('Profile picture deleted!'));
        window.location.reload();
      }
    });
  };

  handleChangePhoto = () => {
    let file = this.refs.changeFile.files[0];
    let reader = new FileReader();
    let url = reader.readAsDataURL(file);

    if (!validateImageFileExtension(file.name)) return false;
    reader.onloadend = () => {
      this.setState({
        imgSrc: reader.result.toString(),
        file,
        firstUpload: false,
      });
      this.refs.changeFile.value = '';
      return false;
    };
  };

  render() {
    const profilePic = this.props.userInfo.picture != null ? this.props.userInfo.picture : '';
    customStyles.maxHeight = window.outerHeight * 0.65;
    const { t } = this.props;
    return (
      <div style={{ display: 'inline-block', verticalAlign: 'text-top' }}>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={() => this.setState({ modalIsOpen: false })}
          style={customStyles}
          ariaHideApp={false}
          shouldCloseOnOverlayClick={false}
          contentLabel={t('Crop Image Modal')}
        >
          <h3
            style={{
              display: 'inline-block',
              width: 'auto',
              textTransform: 'capitalize',
              color: 'rgba(0, 0, 0, 0.75)',
              fontWeight: 'bold',
            }}
          >
            {t('Edit Profile Image')}
          </h3>
          <i
            className="icon icon-outline-close-24px cursor-pointer"
            style={{ marginRight: '5px', float: 'right' }}
            onClick={() => this.setState({ modalIsOpen: false })}
          />
          <div className="wb-row">
            <div className="col-md-12 text-center">
              <ReactCrop
                src={this.state.imgSrc}
                crop={this.state.crop}
                onImageLoaded={this.onImageLoaded}
                onComplete={this.onCropComplete}
                onChange={this.onCropChange}
              />
            </div>
            <br />
            <div className="col-md-12 m-t-1">
              <a onClick={this.deletePhoto} className="left delete-user-photo" href="#">
                {t('Delete photo')}
              </a>
              <button onClick={this.saveProfileImage} type="submit" className="gbl-btn right">
                {t('Save')}
              </button>

              <div className="mp-profile-change-btn-wrapper wb-pointer right">
                <button className="mp-upload-btn wb-pointer">{t('Change photo')}</button>
                <input
                  id="change-file-upload"
                  type="file"
                  accept="image/*"
                  title={t('Click here to change your image')}
                  onChange={this.handleChangePhoto}
                  ref="changeFile"
                  className="mp-change-file-input"
                />
              </div>
            </div>
          </div>
        </Modal>
        <div
          id="imgTextDivIE"
          style={{
            textAlign: 'center',
            marginLeft: '15px',
            width: '35%',
            float: 'left',
          }}
          title=""
        >
          <span id="imgTextIE" />
        </div>
        <div
          className="imageDisplay"
          id="imageDisplay"
          style={{ textAlign: 'center', marginLeft: '15px', width: '35%' }}
          title=""
        >
          <img
            id="imgThumb"
            alt="Profile Image"
            className="fitProfileImage roundFramePhoto"
            src={profilePic}
            height="100px"
            width="100px"
          />
        </div>
        <div
          className="imageBrowseButton"
          id="browse"
          style={{
            textAlign: 'center',
            position: 'relative',
            marginTop: '-70px',
            marginLeft: '126px',
            display: 'inline-block',
            width: '40%',
          }}
        >
          <label
            className="changePhotofileContainer"
            onClick={() => this.openProfileDialog(profilePic)}
            style={{ height: '50px', width: '150px' }}
          >
            <p className="changePhotofileLink">{t('Change Photo')}</p>
            {/* <input type="file" ref={"file"} name="file" */}
            {/*       accept="image/*" */}
            {/*       id="RegistrationForm_addphoto" onChange={e => this.getFile(e)} /> */}
          </label>
          <div id="changePhotoDescriptionSpacer" />
        </div>
      </div>
    );
  }
}

/*
 * TextField Comp
 */
class TextField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      testField: this.props.customattributes.ca_value,
    };
    this.saveTextFieldValue = this.saveTextFieldValue.bind(this);
    this.handleProfileChange = this.handleProfileChange.bind(this);
  }

  saveTextFieldValue(e) {
    const { actions } = this.props;
    const attribute = this.props.customattributes;
    const { ccid } = this.props;
    const params = {};
    const customAttrVal = e.target.value;
    params.custom_attribute_id = attribute.id;
    params.custom_attrbute_value = customAttrVal;

    actions.CustomUserAddAttributesValue(ccid, attribute.id, e.target.value);
    $.ajax({
      url: `${wbConfig.baseUrl}/activity/saveCustomAttrValue`,
      type: 'POST',
      dataType: 'json',
      data: params,
    });
  }

  handleProfileChange(e) {
    const _this = this;
    const name = e.target.value;

    _this.setState({
      testField: name,
    });
  }

  render() {
    const attribute = this.props.customattributes;
    const { ccid } = this.props;
    const { actions } = this.props;
    return (
      <div
        className="changeEducation profileSettingFlexContainer"
        style={{ alignItems: 'center' }}
        data-custom-id={attribute.id}
      >
        <label className="profileSettingLabel profileCarrerAsp" for={attribute.id}>
          {attribute.name}
          <span className="typefacetext">{attribute.is_required == '1' && '*'}</span>
        </label>

        <input
          size="60"
          maxLength="128"
          style={{
            color: '#000000',
            paddingLeft: '5px',
            boxSizing: 'border-box',
          }}
          className="profilePageInput profilePageFirstName profileEducationText"
          id={attribute.id}
          type="text"
          value={this.state.testField}
          onChange={(e) => this.handleProfileChange(e)}
          onBlur={(e) => this.saveTextFieldValue(e)}
        />
        {attribute.tooltip_description != '' && (
          <div title={attribute.tooltip_description} className="toolTipDiscription">
            <StyledIconButton
              aria-describedby="objective_alignment-help_tooltip"
              aria-label="Help"
              id="objective_alignment-help_tooltip_id"
            >
              <HelpOutline />
            </StyledIconButton>
          </div>
        )}
      </div>
    );
  }
}

class TextArea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      testField: this.props.customattributes.ca_value,
    };
    this.saveTextAreaValue = this.saveTextAreaValue.bind(this);
    this.handleProfileChange = this.handleProfileChange.bind(this);
  }

  saveTextAreaValue(e) {
    const { actions } = this.props;
    const attribute = this.props.customattributes;
    const { ccid } = this.props;
    const params = {};
    const customAttrVal = e.target.value;
    params.custom_attribute_id = attribute.id;
    params.custom_attrbute_value = customAttrVal;

    actions.CustomUserAddAttributesValue(ccid, attribute.id, e.target.value);
    $.ajax({
      url: `${wbConfig.baseUrl}/activity/saveCustomAttrValue`,
      type: 'POST',
      dataType: 'json',
      data: params,
    });
  }

  handleProfileChange(e) {
    const _this = this;
    const name = e.target.value;

    _this.setState({
      testField: name,
    });
  }

  render() {
    const attribute = this.props.customattributes;
    const editField = !!this.props.customattributes.canEdit;
    const { t } = this.props;
    const minHeightDisplay = this.state.testField == null && editField ? '100px' : '100px';
    return (
      <div
        className="profileSettingFlexContainer"
        style={{
          height: 'auto',
          minHeight: minHeightDisplay,
        }}
        data-custom-id={attribute.id}
      >
        <label className="profileSettingLabel profileCarrerAsp" for={attribute.id}>
          {attribute.name}
          <span className="typefacetext">{attribute.is_required == '1' && '*'}</span>
        </label>

        <textarea
          style={{
            boxSizing: 'border-box',
            fontWeight: 'normal',
            padding: '5px',
            minHeight: '100px',
          }}
          className="gbl-text-entry profileSettingInput profileSettingTextbox input profilePageInput profilePageFirstName"
          id={attribute.id}
          type="text"
          data-id={attribute.id}
          value={this.state.testField}
          onChange={(e) => this.handleProfileChange(e)}
          onBlur={(e) => this.saveTextAreaValue(e)}
          placeholder={t('Type here')}
        />
        {attribute.tooltip_description != '' && (
          <div title={attribute.tooltip_description} className="toolTipDiscription">
            <StyledIconButton
              aria-describedby="objective_alignment-help_tooltip"
              aria-label="Help"
              id="objective_alignment-help_tooltip_id"
            >
              <HelpOutline />
            </StyledIconButton>
          </div>
        )}
      </div>
    );
  }
}

class DropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: false,
      selectedprefernce: '',
    };
    this.handleClick = this.handleClick.bind(this);
    this.clickShowList = this.clickShowList.bind(this);
    this.updateLanguage = this.updateLanguage.bind(this);
  }

  componentDidMount() {
    window.addEventListener('click', this.handleClick, true);
  }

  handleClick(e) {
    if (
      !$('.dropDownClick').is(e.target) && // if the target of the click isn't the container...
      $('.dropDownClick').has(e.target).length === 0
    ) {
      const _this = this;
      _this.setState({
        showPopup: false,
      });
    }
  }

  clickShowList(id) {
    const _this = this;
    if (_this.state.showPopup == id) {
      setTimeout(() => {
        _this.setState({
          showPopup: false,
        });
      }, 5);
    } else {
      setTimeout(() => {
        _this.setState({
          showPopup: id,
        });
      }, 5);
    }
  }

  updateLanguage(lang) {
    this.setState({
      selectedprefernce: lang,
    });
  }

  render() {
    const attribute = this.props.customattributes;
    const { ccid } = this.props;
    let selectedDrop;
    if (ccid == 'language_preference') {
      selectedDrop = attribute.ca_value ? attribute.ca_value : LocaleToLanguageMapper(DEFAULT_LOCALE_CODE_PREFERENCE);
    } else {
      selectedDrop = attribute.ca_value != null ? attribute.ca_value : 'Dropdown List';
    }

    return (
      <div className="changeEducation profileSettingFlexContainer" data-custom-id={attribute.id}>
        <label
          className={attribute.name ? 'profileSettingLabel profileCarrerAsp' : ''} // without the check for attribute.name, the drop-down's position will be indented even when there is no label name
          for={'dropdown-' + attribute.id}
        >
          {attribute.name}
          <span className="typefacetext">{attribute.is_required == '1' && '*'}</span>
        </label>
        <div
          className="block dropdown popupClcik dropDownClick profileSettingInput"
          onClick={(e) => this.clickShowList(attribute.id)}
          id={'dropdown-' + attribute.id}
        >
          <div
            className="selFieldType"
            style={{
              border: !attribute.name && '1px solid rgba(0, 0, 0, 0.5)',
              display: 'inline-block',
              width: '100%',
              boxSizing: 'border-box',
              position: 'relative',
            }}
          >
            <div className="selTextField" style={{ display: 'block', width: '100%', padding: '2px 0px 2px 0px' }}>
              {this.state.selectedprefernce.length < 1 ? selectedDrop : this.state.selectedprefernce}{' '}
            </div>
            <ImgIconComp
              className="dropDIcon"
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
              }}
              id="arrow_down_gray"
              width="13"
              height="10"
            />
          </div>
          {this.state.showPopup == attribute.id && (
            <FieldTypeSelect
              selFieldType={attribute.field_values}
              cusId={attribute.id}
              ccid={this.props.ccid}
              actions={this.props.actions}
              updateLanguage={this.updateLanguage}
            />
          )}
        </div>
        {attribute.tooltip_description && attribute.tooltip_description != '' && (
          <div title={attribute.tooltip_description} className="toolTipDiscription">
            <StyledIconButton
              aria-describedby="objective_alignment-help_tooltip"
              aria-label="Help"
              id="objective_alignment-help_tooltip_id"
            >
              <HelpOutline />
            </StyledIconButton>
          </div>
        )}
      </div>
    );
  }
}

class FieldTypeSelect extends React.Component {
  constructor(props) {
    super(props);
    this.saveDropDownValue = this.saveDropDownValue.bind(this);
  }

  saveDropDownValue(e, value, lang) {
    const { actions } = this.props;
    const { ccid } = this.props;
    const { cusId } = this.props;
    const { updateLanguage } = this.props;
    const params = {};
    const customAttrVal = value;

    params.custom_attribute_id = cusId;
    params.custom_attrbute_value = customAttrVal;
    if (ccid === 'language_preference') {
      const User = {};
      User.language = customAttrVal;
      const type = ccid;
      FormData = {
        User,
        type,
        languageApplyToAllPlatformLabels: this.state.languageApplyToAllPlatformLabels,
      };
      $.ajax({
        url: `${wbConfig.baseUrl}/user/profile/myPreferences`,
        type: 'POST',
        data: FormData,
      })
        .done((resp) => {
          updateLanguage(lang);
          // Only if the POST succeeds should we change the state of the drop-down menu and of wbConfig on the client
          actions.CustomUserAddAttributesValue(ccid, cusId, customAttrVal); // need to update the state via a function here rather than directly (via setState) to avoid memory leak

          // Update wbConfig in real-time otherwise it won't get updated until the next page reload (via loadCssJs(), which invokes AssestsOptimizer::loadAssests(), which invokes renderGlobalJsVariables)
          window.wbConfig.user_locale = customAttrVal;
          // Reload the page so we see the vNext Navigation Menu labels translated into the desired language
          window.location.reload();
        })
        .fail((err) => {
          console.log(`Error when updating language preference; status: ${err.status} ${err.statusText}`);
        });
    } else {
      $.ajax({
        url: `${wbConfig.baseUrl}/activity/saveCustomAttrValue`,
        type: 'POST',
        dataType: 'json',
        data: params,
      });
    }
  }

  render() {
    const { selFieldType } = this.props;
    const { ccid } = this.props;
    const { cusId } = this.props;
    const lis = [];
    // for (var i=0; i< selFieldType.length; i++) {
    // lis.push(<div className="option popupClcik" id={selFieldType[row].value} value={selFieldType[i]} onClick={(e) => this.saveDropDownValue(e)}>{selFieldType[i]}</div>);
    // }
    return (
      <div className="typeSelectWrap" style={{ position: 'relative', top: '5px', width: '100%' }}>
        {Object.keys(selFieldType).map((row, index) => (
          <div
            className="option popupClcik"
            id={row}
            value={selFieldType[row].value}
            key={'key' + row}
            onClick={(e) =>
              this.saveDropDownValue(
                e,
                ccid === 'language_preference' ? selFieldType[row].locale : selFieldType[row].value,
                ccid === 'language_preference' && selFieldType[row].value,
              )
            }
          >
            {selFieldType[row].value}
          </div>
        ))}
      </div>
    );
  }
}

class MultiSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showEditPermission: this.props.showPopupVal,
      selEditId: [],
      selEdit: this.props.customattributes.ca_value ? this.props.customattributes.ca_value.split(',') : [],
      editPermission: this.props.customattributes.field_values,
    };
    this.clickEditPermission = this.clickEditPermission.bind(this);
    this.selEditPermission = this.selEditPermission.bind(this);
    this.saveDropDownValue = this.saveDropDownValue.bind(this);
  }

  clickEditPermission(e, id) {
    e.stopPropagation();
    if (
      !$('.typeSelectWrap').is(e.target) && // if the target of the click isn't the container...
      $('.typeSelectWrap').has(e.target).length === 0
    ) {
      this.props.resetMultiSelect(id);
    }
  }

  selEditPermission(id, sel) {
    // let newElem = this.state.selEdit.length > 0 ? ","+sel : sel;
    const idx = $.inArray(id, this.state.selEditId);
    if (idx == -1) {
      this.state.selEditId.push(id);
    } else {
      this.state.selEditId.splice(idx, 1);
    }
    const idStr = $.inArray(sel, this.state.selEdit);
    if (idStr == -1) {
      this.state.selEdit.push(sel);
    } else {
      this.state.selEdit.splice(idStr, 1);
    }
    this.state.editPermission.map((el) => {
      if (el.role_id == id) {
        el.checkItem = !el.checkItem;
      }
    });
    this.saveDropDownValue();
  }

  saveDropDownValue(e) {
    const { actions } = this.props;
    const { ccid } = this.props;
    const cusId = this.props.customattributes.id;
    const params = {};

    params.custom_attribute_id = cusId;
    params.custom_attrbute_value = this.state.selEdit.toString() || null;

    actions.CustomUserAddAttributesValue(ccid, cusId, params.custom_attrbute_value);
    $.ajax({
      url: `${wbConfig.baseUrl}/activity/saveCustomAttrValue`,
      type: 'POST',
      dataType: 'json',
      data: params,
    });
  }

  render() {
    const attribute = this.props.customattributes;
    return (
      <div className="changeEducation profileSettingFlexContainer" data-custom-id={attribute.id}>
        <label className="profileSettingLabel profileCarrerAsp" for={'multiselect-' + attribute.id}>
          {attribute.name}
          <span className="typefacetext">{attribute.is_required == '1' && '*'}</span>
        </label>

        <div
          className="profileSettingTextbox profileSettingInput input profileEducationText"
          id={'multiselect-' + attribute.id}
        >
          <div
            className="content addedField profileSettingTextbox input "
            style={{
              display: 'inline-block',
              width: '100%',
              boxSizing: 'border-box',
              padding: '0',
              position: 'relative',
            }}
          >
            <div
              className="fieldDropdown popupClick addMargin multiSelectClick"
              onClick={(e) => this.clickEditPermission(e, attribute.id)}
              id={this.state.selEditId}
              tabIndex="4"
              style={{ padding: '5px 10px 5px 10px' }}
            >
              <span className="multiSelectSpan">
                {this.state.selEdit.length > 0 ? this.state.selEdit.toString() : 'Multi-select Dropdown'}
              </span>
              <ImgIconComp
                className="dropDIcon"
                id="arrow_down_gray"
                width="13"
                height="10"
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                }}
              />
              {this.props.showPopupVal == attribute.id && (
                <EditPermission
                  selEditPermission={this.selEditPermission}
                  editPermission={this.state.editPermission}
                  actions={this.props.actions}
                  selectedVal={this.props.customattributes.ca_value}
                />
              )}
            </div>
          </div>
        </div>
        {attribute.tooltip_description != '' && (
          <div title={attribute.tooltip_description} className="toolTipDiscription">
            <StyledIconButton
              aria-describedby="objective_alignment-help_tooltip"
              aria-label="Help"
              id="objective_alignment-help_tooltip_id"
            >
              <HelpOutline />
            </StyledIconButton>
          </div>
        )}
      </div>
    );
  }
}

class EditPermission extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editPermission: this.props.editPermission,
    };
    this.setValue = this.setValue.bind(this);
  }

  setValue(id, value) {
    this.props.selEditPermission(id, value);
  }

  render() {
    const { editPermission } = this.props;
    return (
      <div className="typeSelectWrap" style={{ width: '100%' }}>
        {Object.keys(editPermission).map((row, index) => (
          <div className="customOption" data-value={row} key={index}>
            <div className="grp-meeting-attendee-ckbox ">
              <input
                type="checkbox"
                id={row}
                style={{
                  width: '20px',
                }}
                className="grp-meeting-attendee-select"
                checked={editPermission[row].checkItem}
                value={row}
                data-check={editPermission[row].checkItem}
                onClick={(e) => this.setValue(row, editPermission[row].value)}
              />
              <label htmlFor={row} onClick={(e) => this.setValue(row, editPermission[row].value)} />
            </div>
            <div onClick={(e) => this.setValue(row, editPermission[row].value)}>
              <div className="grp-meeting-user-team truncateText">{editPermission[row].value}</div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default hot(withTranslation()(ProfileApp));
